import { render } from "./ProductDetails.vue?vue&type=template&id=251bddf3"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=251bddf3&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__